import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class Address extends AbstractModel {
  @autoserialize
  personId: number;

  @autoserialize
  stateCode: string;

  @autoserialize
  streetAddress1: string;

  @autoserialize
  streetAddress2: string;

  @autoserialize
  streetAddress3: string;

  @autoserialize
  city: string;

  @autoserialize
  zipCode: string;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  isActive: number;

  get displayAddress(): string {
    return this.streetAddress1 + ' ' + this.city + ', ' + this.stateCode + ' ' + this.zipCode;
  }

  get navigationAddress(): string {
    return this.streetAddress1 + ' ' + this.city + ', ' + this.stateCode + ' ' + this.zipCode;
  }

  equals(address: Address): boolean {
    return (
      this.streetAddress1 === address.streetAddress1 &&
      this.streetAddress2 === address.streetAddress2 &&
      this.streetAddress3 === address.streetAddress3 &&
      this.city === address.city &&
      this.stateCode === address.stateCode &&
      this.zipCode === address.zipCode
    );
  }
}
